import React, { useEffect, useState } from "react";
import { Badge, Button, Offcanvas } from "react-bootstrap";
import classnames from "classnames";
import { PaymentCard } from "../../../features/card/cardTypes";
import {
  useBuyPlanMutation,
  useGetCreditPlanQuery,
} from "../../../features/creditPlan/planApi";
import { PredefinedPlan } from "../../../features/creditPlan/planTypes";
import { toast } from "react-toastify";

interface CreditPlanModalProps {
  defaultPlan: PaymentCard | undefined;
  show: boolean;
  setShow: (show: boolean) => void;
}

const CreditPlanModal: React.FC<CreditPlanModalProps> = ({
  show,
  setShow,
  defaultPlan,
}) => {
  const [predefindPlan, setPredefindPlan] = useState<PredefinedPlan[]>([]);

  const { data } = useGetCreditPlanQuery(undefined);
  const [buyPlan, { isLoading }] = useBuyPlanMutation();

  useEffect(() => {
    if (data?.data) {
      setPredefindPlan(data.data);
    }
  }, [data]);

  return (
    <div>
      <Offcanvas
        show={show}
        onHide={() => setShow(!show)}
        placement={"end"}
        style={{ width: "600px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title className="settings-header px-2 mb-2">
            Buy Gift Credits
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            {predefindPlan.map((plan) => (
              <button
                key={plan.credit_plan_id}
                onClick={() => {
                  setPredefindPlan(
                    predefindPlan.map((item) =>
                      item.credit_plan_id === plan.credit_plan_id
                        ? { ...item, is_default: true }
                        : { ...item, is_default: false }
                    )
                  );
                }}
                className={classnames(
                  plan.is_default ? "occasion-box-selected" : "bg-white",
                  "w-[98%] border shadow p-2 rounded mb-2 mx-2 occasion-box"
                )}
              >
                <div className="flex justify-between">
                  <b>${plan.credit_amount} Gift Credits</b>
                  <b>${plan.amount}</b>
                </div>
              </button>
            ))}

            <div className="mt-4 mb-0 ms-2 fw-medium">
              Payment Method
            </div>

            {defaultPlan && (
              <div className="mt-1 border p-2 rounded mx-2 ">
                {defaultPlan?.brand?.toUpperCase()}{" "}
                <span className="co-name">
                  **** **** **** {defaultPlan.last_4_digits} (
                  {defaultPlan.expiry_date})
                </span>
                <Badge className="ms-3"> Default</Badge>
              </div>
            )}

            <div className="text-right mt-4">
              <Button
                disabled={isLoading}
                onClick={async () => {
                  try {
                    const plan = await buyPlan({
                      credit_plan_id: predefindPlan.find(
                        (plan) => plan.is_default
                      )?.credit_plan_id as string,
                      card_id: defaultPlan?.card_id as string,
                    }).unwrap();
                    toast.success(
                      plan?.message ?? "Plan purchased successfully"
                    );
                    setShow(false);
                  } catch (error: any) {
                    toast.error(error?.message ?? "Something went wrong");
                  }
                }}
              >
                Confirm & Pay ${predefindPlan.find(
                  (plan) => plan.is_default
                )?.amount}
              </Button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default CreditPlanModal;
